import React, { Component } from 'react'
import {Row, Col} from 'react-flexbox-grid'
import CSSModules from 'react-css-modules'
import Styles from './FooterPanel.css'
import config from '../../config'
import { Link } from '../'

@CSSModules(Styles)
export default class FooterPanel extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    // const dfwLogo = require( '../../../static/images/dfw_white.svg' )
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )

    return (
      <div>
        <div styleName='footer-wrap'>
          <div styleName='footer-container'>
            <div styleName='footer-inner'>

              <Row>
                <Col styleName='footer-signup-wrap' xs={12} sm={12} md={6} lg={6}>

                  <div styleName='footer-signup-headline'>
                    Support this work
                  </div>
                  <div styleName='footer-signup-tagline'>
                    <p><span styleName='nowrap'>Tobacco Free Funds</span> is available to all users at no charge, funded by contributions to <span styleName='nowrap'>As You Sow</span></p>
                  </div>
                  <Link
                    to={config.links.donate}
                    bigbutton={true}
                    title='Donate to As You Sow'>
                    Donate <i className='fa fa-angle-double-right'/>
                  </Link>
                </Col>
                <Col styleName='footer-signup-wrap' xs={12} sm={12} md={6} lg={6}>
                  <div styleName='footer-signup-headline'>
                    Get email updates
                  </div>
                  <div styleName='footer-signup-tagline'>
                    <p>We'll keep you up to date with the latest news from <span styleName='nowrap'>As You Sow</span> and <span styleName='nowrap'>Tobacco Free Funds</span></p>
                  </div>
                  <Link
                    to={config.links.signup}
                    bigbutton={true}
                    title='Sign up'>
                    Sign up <i className='fa fa-angle-double-right'/>
                  </Link>
                </Col>
              </Row>

              <div styleName='double-logo'>
                <div styleName='logo-first-wrap'>
                  <Link
                    to={config.links.ays}
                    title='As You Sow'
                    >
                    <img
                      styleName={'logo-ays'}
                      src={aysLogo}
                      alt='As You Sow'
                    />
                  </Link>
                  <div styleName='footer-donate-tagline'>
                    Empowering shareholders<br/>to change corporations for good
                  </div>
                  <div styleName='footer-social-icons-item'>
                    <div styleName='footer-social-label'>
                      As You Sow
                    </div>
                    <Link
                      to={config.links.socialAYSfb}
                      title='As You Sow Facebook'>
                      <i styleName='footer-social-icon' className='fa fa-facebook-official'/>
                    </Link>
                    <Link
                      to={config.links.socialAYStwitter}
                      title='As You Sow Twitter'>
                      <i styleName='footer-social-icon' className='fa fa-twitter'/>
                    </Link>
                    <Link
                      to={config.links.socialAYSinstagram}
                      title='As You Sow Instagram'>
                      <i styleName='footer-social-icon' className='fa fa-instagram'/>
                    </Link>
                  </div>
                </div>

              </div>

              <div styleName='footer-disclaimer-links'>
                <Link
                  to={config.routes.legal}
                  title='Legal'>
                  <span styleName='white'>Legal</span>
                </Link>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link
                  to={config.links.contact}
                  title='Contact'>
                  <span styleName='white'>Contact</span>
                </Link>
              </div>
              <div styleName='footer-disclaimer-text'>

                Copyright &copy; 2018 As You Sow. As You Sow is not an investment advisor, nor do we provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations. <Link to={config.routes.legal} title='Legal'> <span styleName='white'>See our full disclaimer <i className='fa fa-angle-double-right'/></span> </Link>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}